import React, {Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Hidden from '@material-ui/core/Hidden';
import UsersList from './UsersList';
import RegisterUser from './RegisterUser';
import AdminBilling from '../AdminBilling';
import CreateCompany from './CreateCompany';
import Companies from './Companies';
import { isAuthenticated } from '../../auth/index';
import blackLogo from '../../assets/img/gembah-logoblack.png';
import { Redirect} from 'react-router';
import {Link} from 'react-router-dom';
import Footer from '../../components/Footer';

const TabContainer = (props) => {
    return (
      <div>
        {props.children}
      </div>
    );
  }

class AdminDashboard extends Component {

    constructor(props){
        super(props);
        this.state = {
            value: 0,
            redirect: false,
            isEditing: false,
            isInInvoices : false,
            billingOption: '',
            isEditingCompany:false
        };
        this.changeState = this.changeState.bind(this);
    }
   
    
    componentDidMount() {
        if (isAuthenticated().role !== 'administrator' || isAuthenticated().role !== 'staff') {
            return <Redirect to={`/${isAuthenticated().companyActually.slug}`}/>;
        }
    }
    
    handleChange = (event, value) => {
    
       if(value === 0 && this.state.isEditing){
           this.setState({
               value : value,
               isEditing: false
           })
       }
       if(value === 2 && this.state.isInInvoices){
        this.setState({
            value : value,
            isInInvoices: false,
            billingOption:''
        })
        }
        if(value === 4  && this.state.isEditingCompany){
            this.setState({
                value : value,
                isEditingCompany: false,
            })
            }
        this.setState({ value });
    };
    
    returnToAdmin = () => {
        this.setState({ 
            value: 0,
        });
    }  
    
    changeState = (data) => {
        this.setState(data);
    }

    logOut = () => {
        if (isAuthenticated() && isAuthenticated().token) {
            //erase session from local storage
            localStorage.removeItem('gembah_user');
            this.setState({
                redirect: true,
            });
        }
    }
  
    render(){
        const {
            value,
            redirect
        } = this.state;
     
        if (redirect) {
            return <Redirect to="/"/>;
        }

        if (isAuthenticated().role === 'owner' || isAuthenticated().role === 'user') {
            return <Redirect to={`/${isAuthenticated().companyActually.slug}`}/>;
        }

        return(
            <Grid container style={{height: '100%'}} >
                <Grid item xs={12}  style={{maxHeight: '100px'}} className="p-lr-2 p-tb-2 whiteBg">
                    <Hidden xsDown>
                    <div className="floatLeft" id="logoadmin">
                        <Link to={`/${isAuthenticated().companyActually.slug}`}>
                        <img src={blackLogo} width="180" alt="gembah-logo"/>
                        </Link>
                    </div>  
                    </Hidden>
                    <Hidden smUp>
                    <div className="floatLeft" id="logoadmin">
                        <Link to={`/${isAuthenticated().companyActually.slug}`}>
                        <svg width="50px" height="50px" viewBox="0 0 121 141" version="1.1" xmlns="http://www.w3.org/2000/svg">
							<g id="Account" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
								<g id="Dashboard-Login" transform="translate(-660.000000, -169.000000)" fill="#000000" fillRule="nonzero">
									<path d="M731.938427,239.291834 C732.981867,239.938817 734.105572,240.473977 734.916245,240.937249 C742.942707,245.522049 750.912984,250.13081 758.995631,254.643722 C760.296297,255.201839 761.075754,256.542221 760.913955,257.942541 C760.801585,266.808617 760.913955,275.674692 760.841717,284.548755 C760.793558,290.395572 759.445113,295.835029 754.420548,299.501271 C752.51025,300.899075 750.086258,301.601972 747.662267,302.312855 C751.450757,296.370188 750.792587,289.940287 750.80864,283.630197 C750.80864,276.585262 750.760481,269.540326 750.80864,262.495391 C750.983454,261.108836 750.250486,259.7657 748.986633,259.156635 C740.109366,253.948814 731.328416,248.597219 722.0418,243.029963 L731.938427,239.291834 C729.434171,230.433746 725.011591,222.989437 716.872758,218.220927 C708.493132,213.284679 700.129558,208.276545 691.806117,203.348285 C691.472994,203.150961 691.116357,202.984835 690.449645,202.634103 L690.449645,217.17457 L690.439739,217.167773 C690.458442,227.210472 690.482762,237.254896 690.425565,247.295264 C690.425565,256.584674 694.173923,263.589672 702.465259,268.062647 C703.861863,268.80548 705.202282,269.660138 706.566781,270.458884 L720.470478,278.612721 L720.476639,278.566151 L730.773187,284.654756 L731.055516,284.820328 C731.055516,279.892068 731.103675,275.235382 730.991305,270.546746 C730.991305,269.947687 730.124447,269.356615 729.514436,268.949255 L700.932204,251.049368 C704.303318,249.779362 710.684356,247.295264 710.684356,247.295264 C711.325253,247.239453 711.96458,247.41839 712.482283,247.798473 C721.57894,253.155393 730.654193,258.538938 739.708043,263.949108 C740.317661,264.316933 740.738744,264.928028 740.863853,265.626473 C740.863853,276.010165 740.863853,286.345932 740.59898,296.697674 C740.495322,299.595793 739.55943,302.403682 737.902089,304.788966 C736.216248,307.333977 733.545324,309.069305 730.52577,309.581439 C724.176606,310.706735 717.63225,309.545802 712.064907,306.306583 L711.960563,306.242683 L681.403822,288.063235 C677.647438,285.227688 673.505783,282.767552 670.166775,279.484708 C662.766377,272.112287 660.189883,262.615203 660.085539,252.479122 C659.92501,235.705466 660.029354,218.867911 660.085539,202.062305 C660.075301,200.499267 660.223199,198.939174 660.526994,197.405618 C662.902827,185.775884 673.152619,180.983411 683.595046,186.958027 C697.456746,194.849633 711.230155,202.932937 724.754744,211.391652 C733.644956,216.980917 739.567453,224.813089 741.952952,235.502557 L751.226016,231.991299 C752.269456,232.638283 754.171727,234.044075 754.974373,234.507348 C763.000836,239.092147 770.979139,243.692921 779.05376,248.213821 C780.35448,248.768432 781.136932,250.105114 780.980111,251.504653 C780.86774,260.378715 780.980111,267.751136 780.907872,276.617212 C780.859714,282.464029 779.511268,287.903486 774.486703,291.577715 C772.576405,292.97552 770.152413,293.678416 767.728422,294.389299 C771.516912,288.446633 770.858742,282.016731 770.874795,275.706642 C770.874795,268.661706 770.826636,263.110425 770.874795,256.065489 C771.054744,254.677976 770.320245,253.332035 769.052788,252.726733 C760.179475,247.521232 751.193892,241.086759 741.935724,235.521208 L731.938427,239.291834 Z M730.465889,295.556678 C729.985892,294.421021 728.519154,293.726341 728.519154,293.726341 C726.705174,292.799796 721.295339,289.668713 719.168326,288.45462 L719.176529,288.392619 C710.088141,283.0278 700.942969,277.79361 691.990726,272.264049 C684.076634,267.351764 680.239985,260.059217 680.376435,250.737857 C680.488805,242.367004 680.400514,233.996151 680.392488,225.61731 C680.392488,220.501179 680.379616,215.385049 680.383031,210.267467 L680.368408,210.257434 C680.368408,201.215635 680.32025,207.597611 680.408541,198.563799 C680.45014,197.604027 680.077967,196.697622 679.424143,196.046742 L678.530349,195.512592 C673.834868,193.292079 671.386797,194.51416 670.375463,199.690031 C670.180699,200.577457 670.073173,201.481638 670.054405,202.38979 C670.054405,207.870693 670.026312,213.352443 670.000346,218.834212 C669.977885,223.537781 669.957234,228.241358 669.957293,232.944425 C669.95721,239.590622 669.998377,246.235804 670.134669,252.878495 C670.343357,263.134387 674.605409,271.776814 683.643205,277.288158 C696.26883,284.996052 709.071037,292.424385 721.857191,299.868694 C723.319464,300.657245 724.953769,301.076863 726.616883,301.090774 C729.051111,301.153694 729.726584,299.117913 730.35209,297.187197 L730.38722,296.989138 L730.465889,295.556678 Z M688.306579,180.184665 C693.427462,176.550373 698.981774,176.190937 704.447795,179.010509 C709.681048,181.782156 714.57719,185.03305 719.617808,188.124195 C727.895766,193.220192 736.15232,198.348138 744.38747,203.508034 C753.409213,209.17114 758.353514,216.248025 760.849744,226.320206 C761.117615,227.378374 760.549006,228.468911 759.525377,228.860217 L751.258122,231.991299 C749.837438,225.976746 748.352542,221.463834 744.836952,216.679348 C739.852519,210.025798 732.925682,205.904271 726.030951,201.702869 C716.52762,195.903977 707.088501,190.009235 697.512931,184.338142 C694.70367,182.668764 691.517164,181.630394 688.306579,180.184665 Z M711.366605,172.037461 C716.495514,168.411156 722.0418,168.043733 727.515847,170.871292 C732.741074,173.563065 733.640037,174.86502 738.664603,177.956165 C746.931858,183.052161 755.185737,188.180108 763.426238,193.340004 C772.447981,199.003109 777.400309,206.119932 779.888512,216.152176 C780.150648,217.214245 779.575531,218.304056 778.548093,218.692187 L770.288863,221.823269 C768.860153,215.808715 767.375257,211.295803 763.867693,206.50333 C758.939446,199.857767 752.004583,195.73624 745.117878,191.534839 C735.60652,185.775884 730.180632,181.830081 720.605063,176.190937 C717.787775,174.497597 714.57719,173.45124 711.366605,172.037461 Z" id="Combined-Shape"></path>
								</g>
							</g>
						</svg>
                        </Link>
                    </div> 
                    </Hidden>
                                  
                    <div className="floatRight">
                        <p className="m-0">Welcome, {isAuthenticated().first_name}!</p>
                        <button className="logOutAdmin" onClick={this.logOut}>Log out</button> 
                    </div>
                </Grid>
               
                <Grid item md={3} xs={12}  id="sidebarAdmin">
                    <Tabs id="adminTabs" onChange={this.handleChange} value={value}>
                        <Tab label="Registered Users" value={0}/>
                        <Tab label="Add new user" value={1}/>
                        <Tab label="Billing" value={2}/>
                        {
                            isAuthenticated().role === 'administrator' ?
                            <Tab label="Create Company" value={3}/>
                            :
                            null
                        }
                        <Tab label="Companies" value={4}/>
                    </Tabs>
                </Grid>
                <Grid item md={9} xs={12} >
                    {value === 0 &&
                        <TabContainer id="registeredTab">
                            <UsersList change={this.changeState} editing={this.state.isEditing} />
                        </TabContainer>
                    }
                    {value === 1 && 
                        <TabContainer> 
                             <RegisterUser view={this.returnToAdmin.bind(this)}/> 
                        </TabContainer>
                    }
                    {
                        value === 2 &&
                        <TabContainer>
                            <AdminBilling change={this.changeState} billingOption={this.state.billingOption}/>
                        </TabContainer>
                    }
                    {
                        value === 3 &&
                        <TabContainer>
                            <CreateCompany />
                        </TabContainer>
                    }
                    {
                        value === 4 &&
                        <TabContainer>
                            <Companies change={this.changeState} editing={this.state.isEditingCompany}/>
                        </TabContainer>
                    }
                </Grid>
            
                
                <Footer />
            </Grid>
        )
    }

} 
export default AdminDashboard